export default __webpack_public_path__ + "static/media/fb.9ad51e41.png";